/**
 * Personal API Tokens API client (Doc 60).
 */
import { api } from "@/api/client";

export interface ApiTokenItem {
  id: string;
  name: string;
  prefix: string;
  last_used_at: string | null;
  expires_at: string | null;
  revoked_at: string | null;
  created_at: string;
  is_active: boolean;
}

export interface TokensListResponse {
  items: ApiTokenItem[];
  active_count: number;
  limit: number;
}

export interface CreateTokenResponse {
  id: string;
  name: string;
  raw_token: string;
  prefix: string;
  expires_at: string | null;
  created_at: string;
  message: string;
}

export const apiTokensApi = {
  list: (includeRevoked = false) =>
    api.get<TokensListResponse>("/api/v1/me/api-tokens", {
      query: { include_revoked: includeRevoked },
    }),
  create: (name: string, ttlDays?: number | null) =>
    api.post<CreateTokenResponse>("/api/v1/me/api-tokens", {
      name,
      ttl_days: ttlDays ?? null,
    }),
  revoke: (tokenId: string) =>
    api.delete<void>(`/api/v1/me/api-tokens/${tokenId}`),
};
